<script>
import LayoutPublic from "@/components/layouts/public";
import UiCard from "@/components/ui/Card.vue";
import UiSpinner from "@/components/ui/UiSpinner.vue";
import Utils from "@/services/utils.js";

export default {
  name: "PrivacyPolicy",
  components: {
    LayoutPublic,
    UiCard,
    UiSpinner,
  },
  data() {
    return {};
  },
  computed: {
    datis() {},
    brand() {
      return Utils.getApplicationName();
    },
  },
  methods: {},
};
</script>

<template>
  <LayoutPublic :containerWidth="980" :showLang="false">
    <h1 class="text-xl font-semibold mb-4" style="line-height: inherit">
      Politique de confidentialité
    </h1>
    <p class="text-muted">Mise à jour le 01/02/2024.</p>
    <p class="mb-5">
      Pour fonctionner de manière optimale {{ brand }} peut vous demander la
      permission d'utiliser certaines informations ou fonctionalités de votre
      smartphone. Vous trouverez ci-dessous les permissions demandées et
      l'utilisation destinée.
    </p>
    <h2 id="permissions" class="text-lg font-semibold mb-4">
      Permissions requises
    </h2>
    <div style="overflow: auto; margin-inline: -1.5rem" class="px-4 mb-3">
      <table class="table text-sm" style="min-width: 600px">
        <thead>
          <tr>
            <th width="25%">Permission</th>
            <th width="10%">Android</th>
            <th width="10%">iOS</th>
            <th width="55%">Utilisation</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>Position de l'appareil</th>
            <td>
              <i class="fa fa-check text-success-600" aria-label="Oui"></i>
            </td>
            <td>
              <i class="fa fa-check text-success-600" aria-label="Oui"></i>
            </td>
            <td>
              <p>
                Utilisée uniquement lorsque la surveillance est active afin de
                connaître votre position (par GPS, Wi-Fi, Bluetooth Low Energy
                et/ou par réseau cellulaire).
              </p>
              <p>
                En cas d'alerte, cette information peut être transmise à un
                <a href="#tiers-habilite">tiers habilité</a> afin que les
                secours soient guidés jusqu'à vous.
              </p>
            </td>
          </tr>
          <tr>
            <th>Bluetooth</th>
            <td>
              <i class="fa fa-check text-success-600" aria-label="Oui"></i>
            </td>
            <td>
              <i class="fa fa-check text-success-600" aria-label="Oui"></i>
            </td>
            <td>
              <p>
                Utilisée uniquement lorsque la surveillance est active afin de
                vous positionner grâces aux technologies liées aux beacons
                bluetooth low energy.
              </p>
              <p>
                Cette information peut être transmise à un
                <a href="#tiers-habilite">tiers habilité</a> afin que les
                secours soient guidés jusqu'à vous.
              </p>
            </td>
          </tr>
          <tr>
            <th>Caméra</th>
            <td>
              <i class="fa fa-check text-success-600" aria-label="Oui"></i>
            </td>
            <td>
              <i class="fa fa-check text-success-600" aria-label="Oui"></i>
            </td>
            <td>
              Utilisée pour :
              <ul>
                <li>
                  Le flash de l'appareil photo avant Android 6.0 et ainsi
                  signifier qu'une alarme s'est déclenchée.
                </li>
                <li>Détecter les QR code</li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>Microphone</th>
            <td>
              <i class="fa fa-check text-success-600" aria-label="Oui"></i>
            </td>
            <td>
              <i class="fa fa-check text-success-600" aria-label="Oui"></i>
            </td>
            <td>
              Utilisé pour laisser des instructions vocales (optionnel) lors de
              l'entrée en zone blanche.
            </td>
          </tr>
          <tr>
            <th>SMS</th>
            <td>
              <i class="fa fa-check text-success-600" aria-label="Oui"></i>
            </td>
            <td><i class="fa fa-times text-red-500" aria-label="Non"></i></td>
            <td>
              Utilisée pour :
              <ul>
                <li>
                  Envoyer les alertes par SMS au numéro que vous avez configuré
                  en version gratuite
                </li>
                <li>
                  Envoyer des SMS d'alertes à votre télésurveilleur si vous en
                  avez configuré un.
                </li>
                <li>
                  Envoyer un SMS à notre plateforme depuis votre smartphone lors
                  de l'activation d'une licence professionnelle afin d'être en
                  mesure de connaître votre numéro de téléphone qui peut être
                  utilisé pour vous joindre en cas d'alerte ou de perte de
                  liaison si la connexion de données ne fonctionne pas.
                </li>
              </ul>
              Votre numéro peut également être partagé avec un
              <a href="#tiers-habilite">tiers habilité</a> qui serait chargé de
              piloter les secours.
            </td>
          </tr>
          <tr>
            <th>Liste de contacts</th>
            <td>
              <i class="fa fa-check text-success-600" aria-label="Oui"></i>
            </td>
            <td><i class="fa fa-times text-red-500" aria-label="Non"></i></td>
            <td>
              <p>
                Utilisée uniquement pour choisir un contact pour la levée de
                doute en mode Freemium.
              </p>
              <p>
                La liste des contacts n'est en aucun cas téléversée ou stockée
                vers les serveurs.
              </p>
              <p>
                Le numéro de contact choisi pour la levée de doute n'est en
                aucun cas téléversé ou stocké sur les serveurs.
              </p>
            </td>
          </tr>
          <tr>
            <th>Téléphone</th>
            <td>
              <i class="fa fa-check text-success-600" aria-label="Oui"></i>
            </td>
            <td><i class="fa fa-times text-red-500" aria-label="Non"></i></td>
            <td>
              Utilisée pour :
              <ul>
                <li><span>Avoir accès à l'envoi de SMS</span></li>
                <li>
                  Appeler pour vous des numéros présents dans le répertoire
                  partagé d'entreprise.
                </li>
                <li>
                  Répondre aux appels automatiquement lorsque l'option décroché
                  automatique est activée
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>Service d'accessibilité</th>
            <td>
              <i class="fa fa-check text-success-600" aria-label="Oui"></i>
            </td>
            <td><i class="fa fa-times text-red-500" aria-label="Non"></i></td>
            <td>
              Utilisée pour :
              <ul>
                <li>
                  Détecter les appuis longs sur les boutons de volume et ainsi
                  déclencher les alertes agression
                </li>
                <li>
                  Afficher le bouton SOS virtuel et les alertes par dessus
                  l'écran de verrouillage et les notifications sur Android 8.0+
                  >
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>Accès aux notifications</th>
            <td>
              <i class="fa fa-check text-success-600" aria-label="Oui"></i>
            </td>
            <td><i class="fa fa-times text-red-500" aria-label="Non"></i></td>
            <td>
              Nécessaire pour répondre aux appels entrants lorsque l'option
              décroché automatique est activée sur les appareils sous Android
              5.0 à 7.1.
            </td>
          </tr>
          <tr>
            <th>Rythme cardiaque</th>
            <td><i class="fa fa-times text-red-500" aria-label="Non"></i></td>
            <td>
              <i class="fa fa-check text-success-600" aria-label="Oui"></i>
            </td>
            <td>
              Utilisée pour :
              <ul>
                <li>
                  Uniquement lors d'une alerte, envoyer votre rythme cardiaque
                  afin d'apporter la meilleure prise en charge possible.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>Numéro de téléphone</th>
            <td>
              <i class="fa fa-check text-success-600" aria-label="Oui"></i>
            </td>
            <td><i class="fa fa-times text-red-500" aria-label="Non"></i></td>
            <td>
              Utilisé pour l'option "décrochage automatique" en cas d'alerte.
            </td>
          </tr>
          <tr>
            <th>Nom & email</th>
            <td>
              <i class="fa fa-check text-success-600" aria-label="Oui"></i>
            </td>
            <td>
              <i class="fa fa-check text-success-600" aria-label="Oui"></i>
            </td>
            <td>
              Mode Freemium : utilisé à des fins analytiques et marketing, dans
              le cas ou plusieurs personnes font partie d'une même entreprise ou
              s'inscrivent avec la même adresse mail, on pourra vous proposer de
              passer au mode Premium.
            </td>
          </tr>
          <tr>
            <td colspan="4"></td>
          </tr>
        </tbody>
      </table>
    </div>

    <small class="d-block">
      <strong id="tiers-habilite">Tiers habilité: </strong>
      Un tiers habilité est une personne physique (personne responsable de
      l'exploitation des DATI dans votre entreprise par exemple) ou une
      organisation (télésurveilleur par exemple) qui est chargée de traiter les
      alertes remontées. Les données vous concernant associées à l'alerte
      (position, numéro de téléphone, etc.) sont utilisées pour vous contacter
      et/ou avoir le plus d'informations contextuelles sur le lieu de l'accident
      afin d'y envoyer les secours.
    </small>
  </LayoutPublic>
</template>

<style scoped lang="scss">
.LayoutPublic .table {
  th,
  td {
    align-content: start;
    padding: 0.75rem;

    *:last-child {
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }
  ul {
    padding-left: 1.5em;
  }
}
</style>
